import { Check } from "lucide-react";
import { Reveal, Chapter } from "../components/Reveal";

const PRACTICES = [
  "Private and cosmetic dental practices",
  "Implant-focused practices",
  "Invisalign and ortho-led practices",
  "Practices offering higher-value treatments",
  "Practices handling enquiries across multiple channels",
];

export default function WhoFor() {
  return (
    <section
      id="who"
      data-testid="who-section"
      className="scroll-mt-24 border-t border-ink/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
          <Reveal>
            <Chapter number="08" label="Who It's For" />
          </Reveal>
          <Reveal delay={60}>
            <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Who this is built for
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-6 text-base leading-relaxed text-ink/70 md:text-lg">
              Leadtochair tends to be the strongest fit for practices where
              enquiry volume and treatment value make a structured follow-up
              process worthwhile.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 max-w-3xl">
          {PRACTICES.map((p, i) => (
            <Reveal key={p} delay={i * 90}>
              <div
                data-testid={`who-item-${i}`}
                className="flex items-center gap-4 border-b border-ink/10 py-4"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-soft">
                  <Check size={14} className="text-teal" strokeWidth={2.5} />
                </span>
                <p className="text-base text-ink/80">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div
            data-testid="who-honest-note"
            className="mt-12 max-w-3xl rounded-2xl bg-ink/[0.05] p-7 md:p-8"
          >
            <p className="text-sm leading-relaxed text-ink/70 md:text-base">
              It&apos;s worth being straightforward: if your practice receives
              very few enquiries and one person already responds to all of them
              the same day, Leadtochair may offer less benefit. The value grows
              with enquiry volume and the number of channels involved — and
              we&apos;ll tell you honestly on a call if we don&apos;t think
              it&apos;s the right fit.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
